
(function documentTypeDetailControllerDefinition() {
    'use strict';

    angular.module('ContainerType')
        .controller('ContainerTypeDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminContainerTypeService', 'authExtend',
            function containerTypeDetailController($scope, config, $state, $translate, $stateParams, errors, adminContainerTypeService, authExtend) {
                $translate(['ContainerTypeDetail']).then(function (translated) {
                    $scope.title = translated.ContainerTypeDetail;
                });

                $scope.hideAddBtn = !authExtend.isInRole('METADATA WRITE') || !authExtend.isInRole('METADATA READ');
                $scope.viewAll = authExtend.isInRole('CONFIG ADMIN APPS');
                $scope.enableviewIndex = authExtend.isInRole('VIEW INDEX') || authExtend.isInRole('EDIT AND DELETE INDEX');

                adminContainerTypeService.getById($stateParams.id, 'Detail').then(function (result) {
                    $scope.containerType = result;
                }, function (error) {
                    errors.showError(error);
                    $state.go('container-type-find');
                });

                $scope.cancel = function () {
                    $state.go('container-type-find');
                };

                $scope.view = function (metadata) {
                    $state.go('metadata-detail', { id: metadata.metadataId });
                };

                $scope.viewDocumentType = function (documentType) {
                    $state.go('document-type-detail', { id: documentType.documentTypeId });
                };

                $scope.viewIndex = function () {
                    $state.go('dba-detail', { key: 'TC', id: $scope.containerType.id });
                };
            }
        ]);
})();